import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface DialogZipData {
  address1_PostalCode: string;
}

@Component({
  selector: 'ebb-zipcode-dialog',
  templateUrl: './zipcode-dialog.component.html',
  styleUrls: ['./zipcode-dialog.component.scss']
})
export class ZipcodeDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ZipcodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogZipData
  ) {}

  public onClickClose(): void {
    this.dialogRef.close();
  }
}
